import React from 'react';
import moment from 'moment';
import SelectOption from '../SelectOption';
import { Form, Select } from 'antd';

const { Option } = Select;
const TimePicker = ({
  beginLimit = '12:00 am',
  endLimit,
  step = 30,
  defaultValue,
  onChange,
  value,
  label,
  placeholder,
  name,
  updatedStartTime
}) => {
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!'
    }
  ];
  const isEarlierThanEndLimit = (timeValue, endLimit, lastValue) => {
    let timeValueIsEarlier = moment(timeValue, 'h:mm a').diff(moment(endLimit, 'h:mm a')) < 0;
    let timeValueIsLaterThanLastValue =
      lastValue === undefined
        ? true
        : moment(lastValue, 'h:mm a').diff(moment(timeValue, 'h:mm a')) < 0;
    return timeValueIsEarlier && timeValueIsLaterThanLastValue;
  };

  let options = [];
  let timeValue = beginLimit;
  let lastValue;

  options.push({ title: timeValue, value: timeValue });

  while (isEarlierThanEndLimit(timeValue, endLimit, lastValue)) {
    lastValue = timeValue;
    timeValue = moment(timeValue, 'h:mm a')
      .add(step, 'minutes')
      .format('h:mm a');
    options.push({ title: timeValue, value: timeValue });
  }
  if(updatedStartTime){
    let filteredOptions = []
    let removeVlaue = true;
    options.forEach(opt => {
      if(opt.value === updatedStartTime){
        removeVlaue = false;
      }
      if(!removeVlaue){
        filteredOptions.push(opt)
      }
    });
      options = filteredOptions
    
  }
  return (
    <Select
      placeholder={placeholder}
      onSelect={value => onChange(value)}
      style={{ width: '110px' }}
      value={value}
    >
      {options.map((value, index) => {
        return <Option value={value.value}>{value.title}</Option>;
      })}
    </Select>
  );
};

export default TimePicker;
